/** Home hero carousel + navbar shortcuts (single source of truth). */
export const LANDING_HERO_VIDEOS = [
  {
    id: 1,
    title: "What We Do",
    navShortLabel: "Services",
    url: "https://res.cloudinary.com/ddzllbqlv/video/upload/v1748342620/zjtzamruh1ztnsjntam7.mp4",
    buttonId: "what-we-do",
    path: "/what-we-do",
    description:
      "AI, automation, and product engineering scoped to what your business needs next—not a generic services laundry list.",
    ctaLabel: "Explore services",
  },
  {
    id: 2,
    title: "Custom Solutions",
    navShortLabel: "Custom",
    url: "https://res.cloudinary.com/ddzllbqlv/video/upload/v1748342623/kfeixt00owusza7oaoxw.mp4",
    buttonId: "custom-solutions",
    path: "/custom-solutions",
    description:
      "One-off systems and product builds engineered around your constraints—automation, AI, and integrations with metrics that matter.",
    ctaLabel: "Explore custom work",
  },
  {
    id: 3,
    title: "What We Deliver",
    navShortLabel: "Work",
    url: "https://res.cloudinary.com/ddzllbqlv/video/upload/v1748342633/zdwyblkjivgsog2q2fad.mp4",
    buttonId: "what-we-deliver",
    path: "/case-studies",
    description:
      "Measurable outcomes and shipped work—browse case studies for real projects, timelines, and results.",
    ctaLabel: "View case studies",
  },
];
